import { IonBreadcrumb, IonBreadcrumbs, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonLabel, IonList, IonMenuButton, IonModal, IonPage, IonPopover, IonSearchbar, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react";

import { add, ellipsisHorizontal, home } from 'ionicons/icons';
import { useState, useRef, useEffect } from 'react';
import ProgressBar from '@/components/ProgressBar';
import backend from '@/controllers/backend'
import { get } from '@/controllers/preferences'
import { useHistory, useParams } from "react-router";

import { OverlayEventDetail } from "@ionic/core";
import FolderList from "./FolderList";
import DocumentList from "./DocumentList";

import useQueryParams from "@/controllers/useQueryParams";
import slug from "@/controllers/slug";
import Markdown from "@/components/Markdown";
import { Link } from "react-router-dom";
import PageQR from "@/components/PageQR";
import capitalize from "@/controllers/capitalize";

const name = "Books"
const UserBooksPage: React.FC = () => {
    const uploadRef = useRef<HTMLElement>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const dirLogoFileInputRef = useRef<HTMLInputElement>(null);
    const menuRef = useRef<HTMLIonPopoverElement>(null);
    const startedRef = useRef(false);

    const [uploadProgress, setUploadProgress] = useState<number | null>(null);
    const [isUploading, setIsUploading] = useState(false);
    const [fileName, setFileName] = useState<string | null>(null);
    const [userId, setUserId] = useState(null)

    const [parents, setParents] = useState([])
    const [folder, setFolder] = useState(null)
    const [subfolders, setSubfolders] = useState([])

    const path = useParams()[0];
    const params = useParams();

    // search bar
    const [searchbarActive, setSearchbarActive] = useState(false);
    const [query, setQuery] = useQueryParams();
    ///const [searchParams, setSearchParams] = useSearchParams();

    const searchBarRef = useRef<HTMLIonSearchbarElement>(null);
    useEffect(() => {
        if (!searchBarRef) return;
        searchBarRef.current!.value = query.get('q');
        console.log("setting searchbar")
    }, [searchBarRef])

    const [displayThumb, setDisplayThumb] = useState(false);
    const [thumbUrl, setThumbUrl] = useState("");
    const reloadThumb = () => {
        if (!folder) return;
        if (!folder.thumb) return;
        setThumbUrl(backend.dir_thumb_url(folder.id));
        setDisplayThumb(true)
    }

    const [folderDocs, setFolderDocs] = useState([])
    const [suggestedDocs, setSuggestedDocs] = useState([])

    const later = async (q: string | null = null) => {
        const query_params = {};
        setNoMoreDocs(false);
        docsRepoID.current = "docs";
        if (docsPageNum.current == -1) docsPageNum.current = 0;
        if (query.has("q") || q) {
            query_params.search = q == null ? query.get("q") : q;
        }
        const dir = await backend.dir_get(params.folder_id, query_params)
        setFolder(dir.dir)
        setParents(dir.breadcrumbs)
        setSubfolders(dir.subfolders)
        setUserId(await get("user_id"))

        if (dir.dir && ((params.folder_id !== (''+dir.dir.id)) || (slug(dir.dir.name) !== path))) {
            history.replace(`/folders/${dir.dir.id}/${slug(dir.dir.name)}`)
        }

        // documents
        const a = await backend.dir_get_documents(params.folder_id, "docs", query_params);
        console.log('docs', a)
        setFolderDocs(a.documents)
        if (a.documents.length == 0) {
            const b = await backend.dir_get_documents(params.folder_id, "suggested", query_params)
            console.log('suggested', b.documents)
            setSuggestedDocs(b.documents)
        } else {
            setSuggestedDocs([]);
        }

        if (q) {
            //documentsRef.current?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            setTimeout(() => {
                documentsRef.current?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }, 100);
        }
    }

    // docs pagination
    const [noMoreDocs, setNoMoreDocs] = useState(false);
    const docsPageNum = useRef(0);
    //const [docsPageNum, setDocsPageNum] = useState(0);
    const docsRepoID = useRef("docs");
    const PAGE_SIZE = 20;

    const nextPage = async () => {
        console.log("nextPage called")
        const nextPageNum = docsPageNum.current + 1
        const query_params = { limit: PAGE_SIZE, offset: nextPageNum * PAGE_SIZE };
        const q = null; // TODO
        if (query.has("q") || q) {
            query_params.search = q == null ? query.get("q") : q;
        }
        const dir = await backend.dir_get_documents(params.folder_id, docsRepoID.current, query_params)
        if (docsRepoID.current == "docs") {
            console.log("setting folder docs")
            setFolderDocs((prev) => [...prev, ...dir.documents])
        } else {
            console.log("setting suggested docs")
            setSuggestedDocs((prev) => [...prev, ...dir.documents])
        }
        docsPageNum.current = nextPageNum
        if (dir.documents.length == 0) {
            if (docsRepoID.current == "docs") {
                docsPageNum.current = -1;
                docsRepoID.current = "suggested";
                console.log("switching to suggested pagination")
                // const b = await backend.dir_get_documents(params.folder_id, "suggested", query_params)
                // console.log('suggested', b.documents)
                // setSuggestedDocs(b.documents)
            } else {
                setNoMoreDocs(true);
                console.log("done")
            }
        }
    }

    useEffect(() => {
        reloadThumb();
    }, [folder])

    useEffect(() => {
        //if (startedRef.current) return;
        //startedRef.current = true;
        later()
    }, [params])

    useEffect(() => {
        if (folder?.name) {
            document.title = folder?.name;
        } else {
            document.title = 'Convolution: Home'
        }
        //document.title = "Convolution: " + (folder?.name || "Home")
    }, [params, folder])

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;
        for (const file of files) {

            // Set uploading state
            setIsUploading(true);
            setFileName(`Uploading: ${file.name}`);
            setUploadProgress(0);

            // UI update
            menuRef.current?.dismiss();
            setTimeout(() => {
                uploadRef.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }, 40);

            try {
                await backend.upload_doc(file, (progress) => {
                    setUploadProgress(progress);
                }, params.folder_id);
                
                // Start pulling TOC
                // TODO: move to server side?
                // NOTE: no await so we don't wait till toc is done
                //backend.toc(await get("user_id"), file.name, path);

                // Refresh the docs list after upload
                later();
            } catch (error) {
                console.error("Upload failed:", error);
            } finally {
                // Reset uploading state
                setIsUploading(false);
                setUploadProgress(null);
                setFileName(null);
            }
        }
    };

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleLogoFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;
        const file = files[0];

        await backend.dir_set_logo(params.folder_id, file);
        later(); // refresh page
        //setTimeout(() => reloadThumb(), 200);
    }

    const history = useHistory()
    const newFolderModalRef = useRef<HTMLIonModalElement>(null)
    const newFolderInputRef = useRef<HTMLIonInputElement>(null);
    const submitNewFolder = async (event: CustomEvent<OverlayEventDetail>) => {
        if (event.detail.role === 'confirm') {
            const folderName = newFolderInputRef.current?.value
            if (!folderName) return;
            const newDir = await backend.dir_create(''+folderName, params.folder_id)
            history.push(`/folders/${newDir.id}/${newDir.name}`)
        }
    }

    const folderNameRef = useRef<HTMLIonInputElement>(null)

    const setFolderName = async () => {
        const value = "" + folderNameRef.current!.value!
        await backend.dir_change(folder.id, { name: value })
        later();
        // const dir = await backend.dir_get(params.folder_id, query_params)
        // setFolder(dir.dir)
        // setParents(dir.breadcrumbs)
        // setSubfolders(dir.subfolders)
        // history.push(`/folders/${dir.dir.id}/${dir.dir.name}`)
    }

    const foldersMenuRef = useRef<HTMLIonPopoverElement>(null);

    const [editShare, setEditShare] = useState(false);
    const [editDescription, setEditDescription] = useState(false);
    const shareOptions = ["private", "link", "public"];

    const documentsRef = useRef<HTMLDivElement>(null);
    return (
    <IonPage>
        <IonHeader className="shadow-none">
            <IonToolbar className="shadow-md">
                <IonButtons slot="start" className={searchbarActive ? "max-sm:hidden" : ""}>
                    <IonMenuButton />
                </IonButtons>
                <IonSearchbar 
                    ref={searchBarRef}
                    style={{'--box-shadow': 'none'}}
                    placeholder="Search..."
                    debounce={400}
                    onIonBlur={() => setSearchbarActive(false)}
                    onIonFocus={() => setSearchbarActive(true)}
                    onIonInput={(e) => {
                        const q = e.detail.value;
                        later(q);
                        setQuery({ q });
                        //documentsRef.current?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                    }}
                ></IonSearchbar>
                <IonButtons slot="end" className={"mr-2 " + (searchbarActive ? "max-sm:hidden" : "")}>
                    <IonButton onClick={(e) => {menuRef.current!.present(e)}} strong={true}>
                        <IonIcon icon={add} />
                    </IonButton>
                    <IonPopover ref={menuRef} reference="event">
                        <IonContent class="">
                            <IonList>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Upload Documents</IonItem>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Link YouTube video/playlist</IonItem>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Link Web Page</IonItem>
                                <IonItem
                                    button
                                    // routerLink={`/folders/${path ? path + "/" : ""}new_folder`}
                                    onClick={() => {
                                        menuRef.current?.dismiss()
                                        newFolderModalRef.current?.present()
                                        //newFolderInputRef.current?.setFocus()
                                        setTimeout(() => newFolderInputRef.current?.setFocus(), 100)
                                    }}
                                    //id="open-modal"
                                >New Folder</IonItem>
                            </IonList>
                        </IonContent>
                    </IonPopover>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonModal style={{'--height': '10em'}} ref={newFolderModalRef} onWillDismiss={submitNewFolder}>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={() => newFolderModalRef.current?.dismiss()}>Cancel</IonButton>
              </IonButtons>
              <IonTitle>Create New Folder</IonTitle>
              <IonButtons slot="end">
                <IonButton strong={true} onClick={() => newFolderModalRef.current?.dismiss(null, 'confirm')}>
                  Confirm
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem>
              <IonInput
                label="Enter folder name"
                labelPlacement="stacked"
                ref={newFolderInputRef}
                type="text"
                placeholder="Folder name"
                onKeyDown={(e) => { if (e.key === 'Enter') {
                    e.preventDefault()
                    newFolderModalRef.current?.dismiss(null, 'confirm')
                } }}
              />
            </IonItem>
          </IonContent>
        </IonModal>

        <IonContent fullscreen>
            <IonHeader collapse="condense">
                <IonToolbar>
                    <IonTitle size="large">{name}</IonTitle>
                </IonToolbar>
            </IonHeader>

    <div ref={uploadRef} className={`max-w-md mx-auto shadow-md rounded-xl overflow-hidden md:max-w-2xl ${isUploading ? 'pb-6' : ''}`}> 
        <input
            type="file"
            accept=".pdf, .zip"
            onChange={handleFileChange}
            ref={fileInputRef}
            className="hidden"
            multiple
        />
        <input
            type="file"
            accept="image/*"
            onChange={handleLogoFileChange}
            ref={dirLogoFileInputRef}
            className="hidden"
        />

        <ProgressBar progress={uploadProgress} isLoading={isUploading} title={fileName} subtitle="Please wait while your file is being uploaded..." />
    </div>

    {folder && (<>
    <IonItem color="light">
        <IonBreadcrumbs>
            <IonBreadcrumb routerLink="/">
                <IonIcon slot="start" icon={home}></IonIcon>
                Home
            </IonBreadcrumb>
            {parents.map((p, idx) => {return (
                <IonBreadcrumb key={idx} routerLink={`/folders/${p.id}/${p.name}`}>
                    {p.name}
                </IonBreadcrumb>
            )})}
            <IonBreadcrumb>
                <IonInput ref={folderNameRef} value={folder.name} onIonChange={setFolderName}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); setFolderName() } }}
                />
            </IonBreadcrumb>
        </IonBreadcrumbs>
        <div slot="end">
            <IonButton fill="clear" onClick={(e) => {foldersMenuRef.current!.present(e)}}>
                <IonIcon slot="icon-only" icon={ellipsisHorizontal}></IonIcon>
            </IonButton>
            <IonPopover ref={foldersMenuRef} reference="event">
                <IonContent class="">
                    <IonList>
                        <IonItem button={true} onClick={() => {
                            foldersMenuRef.current?.dismiss();
                            setEditShare(true);
                        }}>Share</IonItem>
                        <IonItem button={true} onClick={async () => {
                            await backend.dir_delete(folder.id)
                            foldersMenuRef.current!.dismiss()
                            if (parents.length > 0) {
                                const parent = parents[parents.length - 1]
                                history.push(`/folders/${parent.id}/${parent.name}`)
                            } else {
                                history.push(`/docs/`)
                            }
                        }}>Delete</IonItem>
                        <IonItem button={true} onClick={async () => {
                            if (dirLogoFileInputRef.current) {
                               dirLogoFileInputRef.current.click();
                            }
                            foldersMenuRef.current?.dismiss();
                        }}>Upload Logo</IonItem>
                        <IonItem button={true} onClick={async () => {
                            foldersMenuRef.current?.dismiss();
                            setEditDescription(true);
                        }}>Edit Description</IonItem>
                    </IonList>
                </IonContent>
            </IonPopover>
        </div>
    </IonItem>
    <IonModal isOpen={editShare} onDidDismiss={() => setEditShare(false)}>
        <IonList className="h-full overflow-auto">
        <IonItem lines="none" className="bg-transparent">
        <IonLabel className="w-full">
            <h2 className="font-bold text-xl mb-2 pb-2">
            Edit Share Options
            </h2>
            <p className="pb-2">There are three share options: Private, Link and Public.</p>
            <ul className="markdown">
                <li>By default, only you can see your files.</li>
                <li>If you allow link share, anyone with direct link can read your files.</li>
                <li className="markdown">With public share, your files will be searchable from the <Link to="/">home page</Link>.</li>
            </ul>
        </IonLabel>
        </IonItem>
        <IonItem>
        <IonLabel>Share Option</IonLabel>
        <IonSelect interface="popover" value={folder?.visibility}
            onIonChange={async (e) => {
                if (!folder) return;
                await backend.dir_change(folder.id, { visibility: e.detail.value });
                later();
            }}
        >
            {shareOptions.map(x => (
                <IonSelectOption key={x} value={x}>{capitalize(x)}</IonSelectOption>
            ))}
        </IonSelect>
        </IonItem>

        <div className="pt-5">
            <PageQR desc="Scan this QR code to share this book" />
            <p className="markdown text-center pt-2">Or copy this link:<br/> <a href={document.location.href}>{document.location.href}</a></p>
        </div>
    </IonList>
    </IonModal>
    <IonModal isOpen={editDescription} onDidDismiss={() => setEditDescription(false)}>
        <form className="flex flex-col h-full w-full" onSubmit={async (e) => {
            e.preventDefault();

            const formData = new FormData(e.target);
            const description = formData.get("description");

            await backend.dir_change(folder.id, { description })
            later();
            setEditDescription(false);
        }}>
            <h2 className="m-3">Folder description</h2>
            <textarea defaultValue={folder.description} name="description" className="p-3 flex-1 w-full resize-none" placeholder='Write folder description here (markdown is supported!)'></textarea>
            <IonButton className="m-3 self-end" type="submit">Save</IonButton>
        </form>
    </IonModal>
    </>)}
    {(folder?.description || displayThumb) &&
        <IonItem color="light">
            <div className="w-full desc">
                {/* <div className={`inline-block max-w-2/3 max-sm:max-w-1/3 p-3 ${!folder || !displayThumb ? "hidden" : ""}`}> */}
                    {thumbUrl && <img className="rounded-md max-h-[25vh] inline-block m-auto float-start p-1" src={thumbUrl} onError={() => setDisplayThumb(false)} />}
                {/* </div> */}
                {/* <div className={`desc flex-1 p-4 ${!folder?.description ? "hidden" : ""}`}> */}
                    <Markdown content={folder?.description} />
                    {/* <p className="text-gray-300 mt-1">
                        {folder?.description}
                    </p> */}
                {/* </div> */}
            </div>
        </IonItem>
    }
    {subfolders.length > 0 && (<>
    <IonItem color="light">
        <IonLabel>Subfolders</IonLabel>
    </IonItem>
    <FolderList folders={subfolders} repo_id={userId} />
    </>)}
    <div ref={documentsRef} />
    <DocumentList title="Documents" subtitle="" repo_id="docs" docs={folderDocs} query={query} />
    <DocumentList title="Suggestions" subtitle="" repo_id="suggested" docs={suggestedDocs} query={query} />
    <IonInfiniteScroll
        onIonInfinite={async (event) => {
            await nextPage();
            event.target.complete()
        }}
        disabled={noMoreDocs}
    >
        <IonInfiniteScrollContent></IonInfiniteScrollContent>
    </IonInfiniteScroll>
    {/* this makes scroll to search result behave a bit more sensibly without making the page jump
    FIXME: it just doesn't play nicely with infinite scroll */}
    <div className="h-1/5"></div>
    </IonContent>
    </IonPage>
    )
}

export default UserBooksPage;